// extracted by mini-css-extract-plugin
export default {"navBar":"Nav_navBar__EdNqq","container":"Nav_container__A9FAB","title":"Nav_title__rU6zu","darkMode":"Nav_darkMode__RtAJt"};